import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import PaperFragment from "../../../../helper-components/misc/PaperFragment";
import StackedHeader from "../../../../helper-components/misc/StackedHeader";
import DataGridTable from "../../../../helper-components/table/DataGridTable";

import UserEditForm from "./UserEditForm";

import { createUploadObject } from "../../../../helper-functions/shared/miscUtils";
import { columns, defaultTableOptions } from "../../../../helper-functions/table/users";
import { deleteUsers, queryUsers, updateUser } from "../../../../helper-functions/api/userQueries";

import { getLanguage } from "../../../../config/language/language";

/**
 * Table showing users.
 * If no data found, show error message instead.
 */
export default function UsersTable(props) {
    const users = props.backend.users;

    const showDeleteDialog = () => {
        props.showDialog({
            title: "Delete users(s)",
            message: `Are you sure you want to delete ${users.selected.length} user(s)?

            This action cannot be undone.`,
            actionTitle: "Delete",
            actionColor: "error",
            callback: (confirm) => handleDelete(confirm)
        });
    };

    const showUpdateDialog = () => {
        props.showDialog({
            title: "Edit user",
            message: "Click 'Update' to confirm changes.",
            component: <UserEditForm {...props} row={users.selected?.[0]} callback={(confirm, options) => handleUpdate(confirm, options)} />
        });
    };

    const handleDelete = (confirm) => {
        if (!confirm) return;

        const ids = users.selected.map((q) => q.id);
        deleteUsers(props, { body: { ids }, ids });
    };

    const handleUpdate = (confirm, options = {}) => {
        props.setOpenDialog(false); // Manually close the dialog.
        if (!confirm) return;

        const { row } = options;
        const body = createUploadObject(row, ["form"]);

        props.showSnackbar({ color: "info", message: getLanguage().SNACKBAR_INFO_LOADING });
        updateUser(props, { body, id: row.id });
    };

    return (
        <PaperFragment
            title={
                <StackedHeader
                    {...props}
                    title="Users"
                    subtitle="View and manage users."
                    icons={[
                        {
                            icon: <DeleteIcon />,
                            tooltip: "Delete selected users",
                            disabled: users.selected.length < 1,
                            onClick: showDeleteDialog
                        },
                        {
                            icon: <EditIcon />,
                            tooltip: "Edit selected user",
                            onClick: showUpdateDialog,
                            disabled: users.selected.length !== 1
                        }
                    ]}
                />
            }
            value={
                <DataGridTable
                    {...props}
                    {...defaultTableOptions}
                    rowHeight={60}
                    states={users}
                    columns={columns(props)}
                    query={(options) => queryUsers(props, options)}
                    empty={getLanguage().NO_USERS_FOUND}
                    refresh={10}
                />
            }
        />
    );
}
